import { get } from 'lodash';

import { getTranslatedString } from '@skinsoft/ui';

import { Location } from './location-data-store';

export const id = (location: Location) => get(location, 'id');

export const title = (location: Location, locale: string) =>
    getTranslatedString(get(location, 'genericEntityTitle'), locale) ||
    getTranslatedString(get(location, 'locationCS.name'), locale) ||
    get(location, 'title') ||
    id(location);

export const pathSchema = (location: Location, locale: string) => getTranslatedString(get(location, 'pathSchema.path'), locale)
export const pathIds = (location: Location) => get(location, 'pathIds')

export const translatedTitle = (location: Location, locale: string) =>
    getTranslatedString(get(location, 'translatedTitle'), locale);

export const firstSynonym = (location: Location, locale: string) => {
    const theFirstSynonym = get(location, 'locationCS.synonyms[0]');
    return theFirstSynonym ? getTranslatedString(theFirstSynonym, locale) : null;
}

export const barCode = (location: Location, locale: string) => {
    return getTranslatedString(get(location, 'locationCS.barCodes'), locale);
};

export const identifier = (location: Location, locale: string) => {
    return getTranslatedString(get(
        location,
        'locationCS.barCodes',
        translatedTitle(location, locale) || id(location),
    ), locale);
};

export const fullPath = (location: Location, locale: string) => `${pathSchema(location, locale)}/${title(location, locale)}`
